import React from 'react';
import { format } from 'date-fns';
import { PHONE_NUMBER_UK_MOBILE } from 'jl-design-system/form/fields';
import replaceStringVars from 'jl-design-system/utils/string/replaceStringVars';
import { Message } from 'jl-design-system/components/message/v2/Message';

import CLICK_AND_COLLECT_DATES from './clickAndCollectDates';
import GIFT_MESSAGE from './giftMessage';
import GIFT_RECEIPT_CHECKBOX from './giftReceiptCheckbox';
import getInternationalPhoneNumberConfig from '../../lazy/internationalPhoneNumberConfig';

export const COLLECTOR_DETAILS_FORM_ID = 'collectorDetailsForm';

export const getInstructionOverride = (instruction, availabilityMessageClassName) => (
  <>
    <Message
      body="You can still collect your order within seven days of your selected date."
      className={availabilityMessageClassName}
      title="Co-op stores have limited availability"
      type="information"
    />
    {
      instruction &&
      <div>{ instruction }</div>
    }
  </>
);

export default function getCollectorDetailsFormConfig({
  isGiftReceiptSelected = false,
  instruction,
  dates,
  daysToShowPerPage,
  maxPagesToShow,
  containerClassName,
  selectedDay,
  selectedDayMessageClassName,
  isCollectPlus,
  focusOnSelectedDayMessage,
  disabled,
  showLimitedAvailablityMessage,
  availabilityMessageClassName,
}, hideSubmitButton, submitButtonText) {

  const PHONE_NUMBER = getInternationalPhoneNumberConfig({
    instruction: 'A UK mobile number will allow us to send a text when the order is ready to collect',
  });

  let instructionOverride;

  if (showLimitedAvailablityMessage) {
    instructionOverride = getInstructionOverride(instruction, availabilityMessageClassName);
  }

  const dayPicker = dates ? {
    ...CLICK_AND_COLLECT_DATES,
    required: !selectedDay,
    dates,
    daysToShowPerPage,
    maxPagesToShow,
    containerClassName,
    selectedDay,
    selectedDayMessageTitle: selectedDay ? replaceStringVars('Collect from ${time} on ${date}', {
      time: format(selectedDay, 'h:mma'),
    }) : undefined,
    selectedDayMessageClassName,
    instruction: instructionOverride || instruction,
    focusOnSelectedDayMessage,
    disabled,
  } : undefined;

  const PHONE_NUMBER_FIELD = isCollectPlus ? {
    ...PHONE_NUMBER_UK_MOBILE,
    instruction: '',
  } : PHONE_NUMBER;

  return {
    id: COLLECTOR_DETAILS_FORM_ID,
    fields: [
      dayPicker,
      PHONE_NUMBER_FIELD,
      GIFT_RECEIPT_CHECKBOX,
      (isGiftReceiptSelected && GIFT_MESSAGE),
    ],
    submitButton: hideSubmitButton ? '' : submitButtonText,
  };
}
